import type { NumberInputValue } from '@vtex/admin-ui'
import { Button, csx, NumberInput } from '@vtex/admin-ui'
import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { FormattedMessage } from 'react-intl'
import { useDrawer } from '@/ui/components'
import { useCustomConfig } from '@/core/hooks/useCustomConfig'

import { useOrderForm } from '../../../../core/requests/checkout'
import { CheckoutRoute } from '../../../Checkout/constants'
import { AddToCartSectionWithoutStockDrawer } from './AddToCartSectionWithoutStockDrawer'

type SelectedSku =
  | {
      _id: string
      id: string
    }
  | undefined

export type AddToCartSectionProps = {
  selectedSku: SelectedSku
  hasOffer: boolean | undefined
}

export const AddToCartSection = ({
  selectedSku,
  hasOffer,
}: AddToCartSectionProps) => {
  const { addItemToCartLegacy } = useOrderForm()
  const history = useHistory()
  const [quantity, setQuantity] = useState(1)
  const { sellWithoutStockInHands } = useCustomConfig()

  const addToCartSectionWithoutStockDrawer = useDrawer({
    route: '#/without-stock-drawer',
  })

  const location = useLocation()

  const handleQuantityChange = (newQuantity: NumberInputValue) => {
    setQuantity(+newQuantity)
  }

  const handleAddToCartClick = () => {
    if (!selectedSku) {
      return
    }

    addItemToCartLegacy({
      quantity,
      id: selectedSku._id,
    })

    history.push(CheckoutRoute.Cart)
  }

  const handleAddToCartWithoutStockClick = () => {
    const { pathname, search } = location

    history.push(`${pathname}${search}#/without-stock-drawer`)
  }

  return (
    <>
      {(hasOffer || sellWithoutStockInHands) && (
        <>
          <div
            className={csx({
              display: 'grid',
              gap: '$space-3',
              gridTemplateRows: '1fr',
              '@tablet': {
                gridTemplateColumns: '152px 1fr',
              },
            })}
          >
            <NumberInput
              value={1}
              min={1}
              max={999}
              onChange={handleQuantityChange}
            />
            {hasOffer ? (
              <Button
                size="large"
                onClick={handleAddToCartClick}
                disabled={!selectedSku}
              >
                <FormattedMessage id="add-to-cart" />
              </Button>
            ) : (
              <Button
                size="large"
                onClick={handleAddToCartWithoutStockClick}
                disabled={!selectedSku}
              >
                <FormattedMessage id="without-stock-add-to-cart" />
              </Button>
            )}
          </div>
          <AddToCartSectionWithoutStockDrawer
            isOpen={addToCartSectionWithoutStockDrawer.isOpen}
            onClose={() => addToCartSectionWithoutStockDrawer.onClose()}
            handleAddToCart={handleAddToCartClick}
          />
        </>
      )}
    </>
  )
}
